import {appConfig} from '@/config/appConfig';
import {useDeviceStorage} from '@/shared/composables/useDeviceStorage/useDeviceStorage';
import {useAccountStore} from '@/stores/accountStore';
import {createSharedComposable} from '@vueuse/core';
import {storeToRefs} from 'pinia';
import {computed} from 'vue';

const staticSubDomain = window.location.hostname.split('.').shift() ?? null;

export const useSubDomain = createSharedComposable(() => {
    const {account} = storeToRefs(useAccountStore());

    const userProvidedSubDomain = useDeviceStorage<string | null>('oidc_subdomain', null);

    const subDomain = computed(() => {
        if (appConfig.isHybridApp) {
            return userProvidedSubDomain.value;
        }
        return account.value?.customSubdomain ?? staticSubDomain;
    });

    return {subDomain, userProvidedSubDomain};
});
